export default __webpack_public_path__ + "static/media/devolucion.e052e903.pdf";